/**
 * @file SignupController
 * @description
 * Load into your application like `myApp.controller('SignupController', require('SignupController.js'))`
 */
module.exports = ["$scope", "CTHashService", "DataService", "ChannelRepository", "AppConstants", "CommitmentModel", "$q", "CTServiceAPI", "CTServiceAPIConfig", function($scope, CTHashService, DataService, ChannelRepository, AppConstants, CommitmentModel, $q, CTServiceAPI, CTServiceAPIConfig) {
    const _controller = this,
          _channel    = ChannelRepository.get(AppConstants.CHANNEL_SUBMISSION.NAME);


    /**
     * Check if the signup form should be opened
     */
    _controller.isOpen = () => !!CTHashService.get('einsenden');


    (function init() {
        $scope.$watch(() => !!CTHashService.get('einsenden'), () => {
            if(!!CTHashService.get('einsenden')) {
                angular.element('body').addClass('modal-open');
            } else {
                angular.element('body').removeClass('modal-open');
            }
        });
    }());
}];
